export default __webpack_public_path__ + "817c3d4908028bf2d2a853e1beb18a18.png";